module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-scroll-response-test"
  }, [_c('div', {
    attrs: {
      "id": "catalog"
    }
  }, _vm._l((_vm.testData), function(v1) {
    return _c('div', {
      staticClass: "catalog-item"
    }, [_c('h1', {
      staticClass: "title"
    }, [_c('a', {
      attrs: {
        "href": '#' + v1.title
      }
    }, [_vm._v(_vm._s(v1.title))])]), _vm._l((v1.children), function(v2) {
      return (v1.children) ? _c('h2', {
        staticClass: "title"
      }, [_c('a', {
        attrs: {
          "href": '#' + v2.title
        }
      }, [_vm._v(_vm._s(v2.title))])]) : _vm._e()
    })], 2)
  })), _c('div', {
    ref: "content",
    attrs: {
      "id": "content"
    }
  }, _vm._l((_vm.testData), function(v1) {
    return _c('div', {
      staticClass: "content-item"
    }, [_c('h1', {
      staticClass: "title",
      attrs: {
        "id": v1.title
      }
    }, [_c('a', {
      attrs: {
        "href": '#' + v1.title
      }
    }, [_vm._v(_vm._s(v1.title))])]), _vm._l((v1.children), function(v2) {
      return (v1.children) ? _c('h2', {
        staticClass: "title",
        attrs: {
          "id": v2.title
        }
      }, [_c('a', {
        attrs: {
          "href": '#' + v2.title
        }
      }, [_vm._v(_vm._s(v2.title))])]) : _vm._e()
    })], 2)
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-33a4dc8d"}!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/test.vue
// module id = 9
// module chunks = 0